const getReportsSelector = (state) => state?.report?.reports

export { getReportsSelector }
